export default __webpack_public_path__ + "static/media/Comfortaa-Bold.dab2a145.ttf";